// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImagesSection_imagesSection__024z0{
    margin-top: 15px;
}
.ImagesSection_uploadImageInput__dKkF5{
    display: none;
}
.ImagesSection_uploadImage__\\+jalx{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: 30px;
    padding-bottom: 30px;
    border: 1px dashed #1F363D33;
    border-radius: 28px;
    cursor: pointer;
}
.ImagesSection_download__gQMrZ{
    height: 20px;
    width: 16px;
}
.ImagesSection_uploadHeader__8jsF6{
    margin-top: 10px;
    color: #40798C;
    font-family: 'Gotham Medium', serif;
}
.ImagesSection_uploadDescription__LW4FG{
    margin-top: 3px;
    color: #1F363D;
    font-size: 12px;
    opacity: 60%;
}
.ImagesSection_images__8qa04{
    display: flex;
    flex-wrap: wrap;
    margin-top: 15px;
}
.ImagesSection_imageContainer__STVCl{
    position: relative;
    height: 89px;
    margin-bottom: 8px;
}
.ImagesSection_imageContainer__STVCl:not(:nth-child(3n)){
    margin-right: 12px;
}
@media(max-width: 1370px){
    .ImagesSection_images__8qa04{
        justify-content: center;
    }
    .ImagesSection_imageContainer__STVCl{
        margin-bottom: 5px;
    }
    .ImagesSection_imageContainer__STVCl:nth-child(3n){
        margin-right: 12px;
    }
}
.ImagesSection_image__rRnZd{
    height: 89px;
    width: 158px;
    border-radius: 6px;
    object-fit: cover;
}
.ImagesSection_sortOrder__LDjVg{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    bottom: 30px;
    left: 5px;
    height: 22px;
    width: 22px;
    color: #FFFFFF;
    background-color: #40798C;
    font-size: 14px;
    font-family: 'Gotham Medium', serif;
    border-radius: 50%;
}
.ImagesSection_leftArrowContainer__ubau5, .ImagesSection_rightArrowContainer__Rudrw{
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 36px;
    height: 15px;
    width: 15px;
    color: #1C1B1F;
    background-color: #FFFFFF;
    border-radius: 50%;
    font-size: 30px;
    cursor: pointer;
}
.ImagesSection_leftArrowContainer__ubau5{
    left: 5px;
}
.ImagesSection_rightArrowContainer__Rudrw{
    right: 5px;
}
.ImagesSection_leftArrow__-DtSw, .ImagesSection_rightArrow__y-5yR{
    height: 5px;
    width: 6px;
}
.ImagesSection_removeImage__qLpy3{
    position: absolute;
    top: 2px;
    right: 2px;
    height: 24px;
    width: 24px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/ImagesSection.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB,4BAA4B;IAC5B,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,mCAAmC;AACvC;AACA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,YAAY;AAChB;AACA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;AACJ;AACA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,mCAAmC;IACnC,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;AACA;IACI,SAAS;AACb;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,WAAW;IACX,eAAe;AACnB","sourcesContent":[".imagesSection{\n    margin-top: 15px;\n}\n.uploadImageInput{\n    display: none;\n}\n.uploadImage{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    padding-top: 30px;\n    padding-bottom: 30px;\n    border: 1px dashed #1F363D33;\n    border-radius: 28px;\n    cursor: pointer;\n}\n.download{\n    height: 20px;\n    width: 16px;\n}\n.uploadHeader{\n    margin-top: 10px;\n    color: #40798C;\n    font-family: 'Gotham Medium', serif;\n}\n.uploadDescription{\n    margin-top: 3px;\n    color: #1F363D;\n    font-size: 12px;\n    opacity: 60%;\n}\n.images{\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 15px;\n}\n.imageContainer{\n    position: relative;\n    height: 89px;\n    margin-bottom: 8px;\n}\n.imageContainer:not(:nth-child(3n)){\n    margin-right: 12px;\n}\n@media(max-width: 1370px){\n    .images{\n        justify-content: center;\n    }\n    .imageContainer{\n        margin-bottom: 5px;\n    }\n    .imageContainer:nth-child(3n){\n        margin-right: 12px;\n    }\n}\n.image{\n    height: 89px;\n    width: 158px;\n    border-radius: 6px;\n    object-fit: cover;\n}\n.sortOrder{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    bottom: 30px;\n    left: 5px;\n    height: 22px;\n    width: 22px;\n    color: #FFFFFF;\n    background-color: #40798C;\n    font-size: 14px;\n    font-family: 'Gotham Medium', serif;\n    border-radius: 50%;\n}\n.leftArrowContainer, .rightArrowContainer{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 36px;\n    height: 15px;\n    width: 15px;\n    color: #1C1B1F;\n    background-color: #FFFFFF;\n    border-radius: 50%;\n    font-size: 30px;\n    cursor: pointer;\n}\n.leftArrowContainer{\n    left: 5px;\n}\n.rightArrowContainer{\n    right: 5px;\n}\n.leftArrow, .rightArrow{\n    height: 5px;\n    width: 6px;\n}\n.removeImage{\n    position: absolute;\n    top: 2px;\n    right: 2px;\n    height: 24px;\n    width: 24px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imagesSection": `ImagesSection_imagesSection__024z0`,
	"uploadImageInput": `ImagesSection_uploadImageInput__dKkF5`,
	"uploadImage": `ImagesSection_uploadImage__+jalx`,
	"download": `ImagesSection_download__gQMrZ`,
	"uploadHeader": `ImagesSection_uploadHeader__8jsF6`,
	"uploadDescription": `ImagesSection_uploadDescription__LW4FG`,
	"images": `ImagesSection_images__8qa04`,
	"imageContainer": `ImagesSection_imageContainer__STVCl`,
	"image": `ImagesSection_image__rRnZd`,
	"sortOrder": `ImagesSection_sortOrder__LDjVg`,
	"leftArrowContainer": `ImagesSection_leftArrowContainer__ubau5`,
	"rightArrowContainer": `ImagesSection_rightArrowContainer__Rudrw`,
	"leftArrow": `ImagesSection_leftArrow__-DtSw`,
	"rightArrow": `ImagesSection_rightArrow__y-5yR`,
	"removeImage": `ImagesSection_removeImage__qLpy3`
};
export default ___CSS_LOADER_EXPORT___;
